import R from '../../core-res/R';
export const tagStyles = theme => ({
    a: Object.assign({}, R.typography.weightMedium, { color: theme.tintPrimary }),
    h1: Object.assign({}, R.typography.headline),
    h2: Object.assign({}, R.typography.title1),
    h3: Object.assign({}, R.typography.title2),
    h4: Object.assign({}, R.typography.title3),
    b: Object.assign({}, R.typography.weightBold),
    strong: Object.assign({}, R.typography.weightBold),
});
export const themeStyle = theme => (Object.assign({ color: theme.darkPrimary, textAlign: 'left' }, R.typography.weightRegular));
